import React from "react";
import styles from "./GroupedHeaderTable.module.css";

/**
 * Reusable table with grouped headers.
 * Example: Segment | FY 2025-26 (Number, Remarks) | FY 2024-25 (Number, Remarks)
 */
const GroupedHeaderTable = ({
  leftColumn = { field: "segment", label: "Segment" },
  groupedColumns = [],
  rows = [],
}) => {
  const flatColumns = groupedColumns.flatMap((group) =>
    (group?.columns || []).map((column) => ({
      ...column,
      groupLabel: group?.label || "",
    })),
  );

  const getCellValue = (row, field) => {
    const value = row?.[field];
    return value === null || value === undefined || value === "" ? "-" : String(value);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr className={styles.headerRow}>
              <th className={styles.headerCell} rowSpan={2}>
                {leftColumn?.label || "Segment"}
              </th>
              {groupedColumns.map((group) => (
                <th
                  key={group?.label}
                  className={styles.headerCell}
                  colSpan={(group?.columns || []).length}
                >
                  {group?.label}
                </th>
              ))}
            </tr>
            <tr className={styles.headerRow}>
              {flatColumns.map((column) => (
                <th key={`${column.groupLabel}-${column.field}`} className={styles.subHeaderCell}>
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.length ? (
              rows.map((row, rowIndex) => (
                <tr key={row?._id || rowIndex} className={styles.bodyRow}>
                  <td className={styles.cell}>{getCellValue(row, leftColumn?.field || "segment")}</td>
                  {flatColumns.map((column) => (
                    <td key={`${row?._id || rowIndex}-${column.field}`} className={styles.cell}>
                      {getCellValue(row, column.field)}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td className={`${styles.emptyCell} noDataCell`} colSpan={1 + flatColumns.length}>
                  No information provided.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GroupedHeaderTable;
